<template>
    <div>
        
        <HowBrushProperly />
    </div>
</template>

<script>

import HowBrushProperly from '../blog-details/HowBrushProperly.vue'

export default {
    components: {
       
        HowBrushProperly,
    }
}
</script>